import { useEffect, useState } from "react";

export function useLocalStorageState<T>(key: string, initialValue: T) {
	/** State */
	const [state, setState] = useState<T>(() => {
		const value = localStorage.getItem(key);
		return value ? JSON.parse(value) : initialValue;
	});

	/** Effects */
	useEffect(() => {
		localStorage.setItem(key, JSON.stringify(state));
	}, [key, state]);

	/** Functions */
	function setValue(value: T) {
		setState(value);
	}

	/** Render */
	return [state, setValue] as const;
}
